export default __webpack_public_path__ + "static/media/chevrons-down.5926567d.svg";